import { render } from "./CurrentCourseMenu.vue?vue&type=template&id=5c2c6597&scoped=true"
import script from "./CurrentCourseMenu.vue?vue&type=script&lang=js"
export * from "./CurrentCourseMenu.vue?vue&type=script&lang=js"

import "./CurrentCourseMenu.vue?vue&type=style&index=0&id=5c2c6597&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2c6597"]])

export default __exports__